module.exports = __webpack_public_path__ + "assets/mastercard.9383b4c4.svg";